import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   DeleteUsageControlvalues
export const DeleteUsageControlvalues = createSlice({
  name: "DeleteUsageControlvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    DeleteUsageControlvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_DeleteUsageControlvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_DeleteUsageControlvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    DeleteUsageControlvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_DeleteUsageControlvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchDeleteUsageControlvalues:(state)=>{
        state.switch = false
    }
  },
});
export default DeleteUsageControlvalues.reducer;
export const {
  DeleteUsageControlvalues_datagrid,
  success_api_call_DeleteUsageControlvalues_datagrid,
  failure_api_call_DeleteUsageControlvalues_datagrid,
  create_DeleteUsageControlvalues_datagrid_complete_api,
  DeleteUsageControlvalues_datagrid_is_success,false_switchDeleteUsageControlvalues
} = DeleteUsageControlvalues.actions;
